// extracted by mini-css-extract-plugin
export default {"field_grid":"VariousOutlayForm_field_grid__8Zvuw","wrapper":"VariousOutlayForm_wrapper__6DK93","action_wrapper":"VariousOutlayForm_action_wrapper__Fuq4o"};